import { CalendarType } from "@/constants/Calendar";
import useCalendarSync from "@/hooks/useCalendarSync";
import { CalendarToggleCard } from "@/ui/components/calendarSync";
import DisableCalendarSyncConfirmationAlert from "@/ui/components/calendarSync/DisableCalendarSyncConfirmationAlert";

interface CalendarSyncStepProps extends ViewWithTestID {
  title?: string;
}

const CalendarSyncStep = ({ testID, title }: CalendarSyncStepProps) => {
  const {
    calendarToDisconnect,
    handleCalendarChange,
    handleConfirmDisable,
    handleDismiss,
    isDeviceCalendarEnabled,
    isGoogleCalendarEnabled,
  } = useCalendarSync();

  return (
    <>
      <CalendarToggleCard
        isDeviceCalendarEnabled={isDeviceCalendarEnabled}
        isGoogleCalendarEnabled={isGoogleCalendarEnabled}
        onDeviceCalendarChange={handleCalendarChange(CalendarType.Apple)}
        onGoogleCalendarChange={handleCalendarChange(CalendarType.Google)}
        testID={testID}
        title={title}
      />
      {calendarToDisconnect && (
        <DisableCalendarSyncConfirmationAlert
          calendarType={calendarToDisconnect}
          isOpen
          onConfirm={handleConfirmDisable}
          onDismiss={handleDismiss}
        />
      )}
    </>
  );
};

export default CalendarSyncStep;
